<template>
  <van-cell class="ry-form__summary">
    <template slot="title">
      <span class="title">{{current.title}}</span>
      <span style="color: red" v-if="!isRead && current.required">*</span>
    </template>
    <template slot="label">

      <template v-if="current.fieldHint">
        <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
        <div
          v-else
          class="ql-editor"
          v-html="current.fieldHint">
        </div>
      </template>
      <div>{{`${current.showTitle}${summaryType}`}}</div>
      <div>
        <br>
        <div class="summary-data">
          汇总数据：{{current.value.summaryValue}}
          <span style="margin-left: 10px">已汇总{{current.value.instanceIdList.length}}条数据</span>
        </div>
        <br>
        <van-button
          type="primary"
          size="small"
          @click="onClickConfirm()">
          查询筛选
        </van-button>
      </div>

      <van-popup
        class="summary-popup"
        v-model="showPopup"
        get-container="body"
        :style="{ height: '90%', width: '100%' }"
        position="bottom">
        <div class="title-container">
          <p>汇总</p>
          <van-icon @click="showPopup = false" name="cross" />
        </div>
        <div class="summary-popup-container" :key="popupKey">

          <div class="filter-container">
            <div
              class="filter-item"
              v-for="item in summaryConfig.conditionList"
              :key="item.fieldId">
              <div class="info">
                <div class="field-title">{{item.fieldTitle}}</div>
                <div
                  v-if="current.showMethod === 1"
                  class="method">
                  {{fetchMethodName(item) }}
                </div>
              </div>
              <div>
                <div
                  v-if="item.method !== FILTER_METHOD_TYPE__EMPTY && item.method !== FILTER_METHOD_TYPE__NOT_EMPTY"
                  class="filter">
                  <component
                    :disabled="isRead"
                    @change="filterChange"
                    :field="fetchFieldFormFieldId(item.fieldId)"
                    :filter-value="item.value"
                    :filter="item"
                    :filter-way="false"
                    :method="item.method"
                    :formId="current.relateFormId"
                    :companyId="$store.getters.currentCompanyId"
                    :appId="current.relateAppId"
                    :is="'filter_' + fetchFieldFormFieldId(item.fieldId).type">
                  </component>
                </div>
              </div>
            </div>
          </div>
          <van-button
            v-if="!isRead"
            class="query-button"
            type="primary"
            size="small"
            @click="summaryConfig.onClickQuery">
            查询
          </van-button>
          <div style="height: 300px;">

            <AllAvailable
              ref="AllAvailable"
              v-if="dataHandleOpts.request"
              :hasSelect="!isRead"
              :lockAmount="!isRead ? 1 : 0"
              :header="dataHandleOpts.header"
              @sorting="dataHandleOpts.sorting"
              @selectionChange="dataHandleOpts.selectionChange"
              @rowClick="dataHandleOpts.rowClick"
              :tableData="dataHandleOpts.dataList">
            </AllAvailable>
          </div>

          <el-pagination
            v-if="dataHandleOpts.request"
            layout="prev, pager, next"
            :current-page.sync="dataHandleOpts.currentPage"
            @current-change="dataHandleOpts.currentChange"
            :page-count="dataHandleOpts.totalPage">
          </el-pagination>
        </div>
        <div class="dialog-footer">
          <div class="footer-data-tip">已选择{{dataHandleOpts.selectionList.length}}条数据</div>
          <div>
            <van-button
              size="small"
              @click="showPopup = false">
              关闭
            </van-button>
            <van-button
              size="small"
              :disabled="!dataHandleOpts.selectionList || !dataHandleOpts.selectionList.length"
              type="primary"
              @click="summaryConfig.confirm">
              确 定
            </van-button>
          </div>
        </div>

      </van-popup>
    </template>
  </van-cell>
</template>

<script>
  import {current} from './mixin'
  import {
    DATA_TYPE__NUMBER,
    DATA_TYPE__STRING, FORM_ITEM__DATE, FORM_ITEM__MEMBER,
    FORM_TYPE__EDIT, FORM_TYPE__FILL, SUCCESS
  } from '../types'
  import FormSet from "../index";
  import FilterValueWidget from "../../component/FilterWidget/FilterValueWidget/index";
  import {
    FILTER_METHOD_TYPE__EMPTY,
    FILTER_METHOD_TYPE__NOT_EMPTY
  } from "../../component/FilterWidget/types";
  import {fetchFieldFilterOpts} from '../../../assets/js/Untis'
  import AllAvailable from "../../component/AllAvailable";

  export default {
    mixins: [current],
    data() {
      return {
        FILTER_METHOD_TYPE__EMPTY,
        FILTER_METHOD_TYPE__NOT_EMPTY,
        DATA_TYPE__STRING,
        showPopup: false,
        popupKey: Math.random(),

        summaryConfig: {
          conditionList: [],
          // 点击查询
          onClickQuery: () => {
            const conditions = this.current.filter.conditionList
            conditions.splice(0, conditions.length, ...this.summaryConfig.conditionList)
            this.dataHandleOpts.currentPage = 1
            this.dataHandleOpts.pageSize = 20
            this.dataHandleOpts.totalPage = 0
            this.dataHandleOpts.totalCount = 0
            this.fetchFormData()
          },
          // 点击汇总
          confirm: () => {
            if (this.isRead) {
              this.showPopup = false
              return
            }
            this.current.value.filter = this.current.filter
            this.current.value.instanceIdList.splice(0, this.current.value.instanceIdList.length, ...this.dataHandleOpts.selectionList)
            const formSet = this.current.root
            if (formSet) {
              console.log(this.dataHandleOpts.selectionList)
              this.$store.dispatch('actionFetchDataSummary', {
                appId: formSet.appId,
                formId: formSet.formId,
                instanceIdList: this.dataHandleOpts.selectionList,
                fieldId: this.current.dataId,
                tmpTopic: formSet.tmpTopic
              })
            }
            this.showPopup = false
          }
        },

        // 数据管理相关操作
        dataHandleOpts: {
          request: false,
          selectList: [],
          header: [],
          submitDataList: [], // 之前提交的数据
          dataList: [],
          currentPage: 1,
          pageSize: 20,
          totalPage: 0,
          totalCount: 0,
          sort: {},
          filter: {},
          // 当前选中的数据
          selectionList: [],
          selectionListMap: {},
          // 数据管理排序sorting
          sorting: sort => {
            this.dataHandleOpts.currentPage = 1
            this.dataHandleOpts.sort = sort
            this.getManagementData()
          },
          // 当前页码修改触发
          currentChange: currentPage => {
            this.getManagementData()
          },
          //
          selectionChange: list => {
            this.dataHandleOpts.selectionListMap[this.dataHandleOpts.currentPage] = list.map(item => item.instanceId)
            this.dataHandleOpts.selectionList.splice(0, this.dataHandleOpts.selectionList.length)
            Object.values(this.dataHandleOpts.selectionListMap).forEach(selectionList => {
              this.dataHandleOpts.selectionList.push(...selectionList)
            })
          },
          // 表格行被点击
          rowClick: (row) => {
          }
        },
      }
    },
    created() {
      if (!this.current.relateFormId) return
      this.fetchFieldList()
    },
    computed: {
      summaryType() {
        return this.current.summaryTypeList.filter(item => item.value === this.current.summaryWay)[0].label
      }
    },
    methods: {
      // 通过fieldId获取method name
      fetchMethodName(condition) {
        let name = ''
        fetchFieldFilterOpts(condition.type).forEach(opt => {
          if (condition.method === opt.method) {
            name = opt.name
          }
        })
        return name
      },

      fetchFieldList() {
        this.$store.dispatch('actionMergeStructure', {
          formId: this.current.relateFormId,
          formType: FORM_TYPE__FILL,
          viewType: 3
        })
          .then(({status, resultObject, info}) => {
            if (status === SUCCESS) {

              let formSet = FormSet.init({
                userId: this.$store.getters.userId,
                companyId: this.$store.getters.currentCompanyId,
                formId: this.current.relateFormId,
                appId: this.current.relateAppId
              })
              formSet.setStructure(resultObject.structureInfo)
              formSet.setPermission(resultObject.permissionInfo.permissionList)
              formSet.setConf(resultObject.detailInfo)

              this.current.filter.conditionList.forEach(condition => {
                const field = resultObject.detailInfo.fieldList.filter(field => field.dataId === condition.fieldId)[0]
                if (field) {
                  condition.fieldTitle = field.fieldTitle
                  condition.type = field.type
                  condition.dataType = field.dataType
                }
              })

              this.relateFormFields = Object.values(formSet.fields)
            } else {
              throw new Error(`${status}: ${info}`)
            }
          }).finally(() => {
          this.endLoading = true
        })
      },

      filterChange() {

      },

      fetchFieldFormFieldId(fieldId) {
        return this.relateFormFields.filter(field => field.dataId === fieldId)[0] || {}
      },
      // 点击查询筛选，
      onClickConfirm() {
        if (!this.current.relateFormId) {
          this.$toast.fail('没有关联的查询表单')
          return
        }

        const conditions = this.summaryConfig.conditionList
        if (this.current.value.filter) {
          conditions.splice(0, conditions.length, ...this.current.value.filter.conditionList)
        } else {
          conditions.splice(0, conditions.length, ...this.current.filter.conditionList)
        }

        const opt = this.dataHandleOpts
        opt.pageSize = 20
        opt.totalPage = 0
        opt.currentPage = 1
        opt.totalCount = 0
        // opt.request = false
        opt.submitDataList.splice(0, opt.dataList.length)
        opt.dataList.splice(0, opt.dataList.length)
        opt.selectionList.splice(0, opt.selectionList.length, ...this.current.value.instanceIdList)

        this.popupKey = Math.random()
        this.showPopup = true

        if (this.current.value.instanceIdList &&
          this.current.value.instanceIdList.length) {
          // 如果是读取状态，就需要先获取之前提交的数据
          this.$store.dispatch('actionApplyHeader', {formId: this.current.relateFormId})
            .then((res = []) => {
              this.dataHandleOpts.request = true
              this.dataHandleOpts.selectList = res.map(item => {
                return {
                  ...item,
                  show: !this.current.hiddenFieldIdList.includes(item.dataId)
                }
              })
              this.selectFieldsLeave()
            })
          this.fetchSubmitFilterData()
        } else {
          // 如果没有设置筛选条件，就直接请求数据
          if (!this.current.filter.conditionList.length) {
            this.summaryConfig.onClickQuery()
          }
        }
      },

      // 获取筛选数据
      fetchFormData() {
        if (!this.dataHandleOpts.request) {
          this.$store.dispatch('actionApplyHeader', {formId: this.current.relateFormId})
            .then((res = []) => {
              this.dataHandleOpts.request = true
              this.dataHandleOpts.selectList = res.map(item => {
                return {
                  ...item,
                  show: !this.current.hiddenFieldIdList.includes(item.dataId)
                }
              })
              this.selectFieldsLeave()
            })
        }
        this.getManagementData()
      },

      // 选择字段弹窗关闭时触发
      selectFieldsLeave() {
        const header = this.dataHandleOpts.header
        const selectList = JSON.parse(JSON.stringify(this.dataHandleOpts.selectList))
        header.splice(0, header.length, ...selectList)
      },
      // 获取筛选数据
      getManagementData() {
        const filter = this.current.filter
        const submitFilter = {
          relation: filter.relation,
          notJumpEmpty: 0, //是否不跳过空值过滤 0 跳过 1 不跳过
          conditionList: filter.conditionList.filter(item => {
            return !(item.method !== 'empty' &&
              item.method !== 'not_empty' &&
              !((item.type === FORM_ITEM__DATE || item.type === FORM_ITEM__MEMBER) && item.fixedValue !== 'fixed_value') &&
              !item.value.length)
          })
        }

        this.$store.dispatch('actionApplyList', {
          appId: this.current.relateAppId,
          formId: this.current.relateFormId,
          currentPage: this.dataHandleOpts.currentPage,
          pageSize: this.dataHandleOpts.pageSize,
          sort: this.dataHandleOpts.sort,
          data: this.current.root.getValues(),
          filter: submitFilter,
          preFilterInfo: this.current.preFilterInfo
        }).then(({currentPage, dataList, totalPage, totalCount, timestamp}) => {
          const opt = this.dataHandleOpts
          opt.totalPage = totalPage
          opt.currentPage = currentPage
          opt.totalCount = totalCount

          if (opt.currentPage > 1) {
            opt.dataList.splice(0, opt.dataList.length, ...dataList)
          } else {
            const instanceIds = opt.submitDataList.map(item => item.instanceId)
            const datas = dataList.filter(item => !instanceIds.includes(item.instanceId))
            opt.dataList.splice(0, opt.dataList.length, ...opt.submitDataList)
            opt.dataList.push(...datas)
          }

          if (this.$refs.AllAvailable) {
            // 设置表格选中之前选中的数据
            this.$refs.AllAvailable.toggleRowSelection(this.current.value.instanceIdList)
          }
        })
      },

      // 获取之前提交的数据
      fetchSubmitFilterData() {
        this.$store.dispatch('actionApplyBatch', {
          appId: this.current.relateAppId,
          formId: this.current.relateFormId,
          instanceIdList: this.current.value.instanceIdList
        }).then(({currentPage, dataList, totalPage, totalCount, timestamp}) => {
          const opt = this.dataHandleOpts
          opt.submitDataList.splice(0, opt.dataList.length, ...dataList)
          opt.dataList.splice(0, opt.dataList.length, ...dataList)
          this.setToggleRowSelection()
        })
      },
      setToggleRowSelection() {
        if (this.$refs.AllAvailable) {
          // 设置表格选中之前选中的数据
          this.$refs.AllAvailable.toggleRowSelection(this.current.value.instanceIdList)
        } else {
          setTimeout(() => {
            this.setToggleRowSelection()
          }, 500)
        }
      }
    },
    components: {
      AllAvailable,
      ...FilterValueWidget
    },
    watch: {}
  }
</script>

<style lang="less">
  .summary-popup {

    .title-container {
      height: 44px;
      background-color: #fff;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #7F8389;
      padding: 0 20px;

      p {
        width: calc(100% - 20px);
        line-height: 44px;
        text-align: center;
      }
    }

    .summary-popup-container {
      height: calc(100% - 88px);
      overflow: auto;
      padding: 10px;

      .filter-container {

        .filter-item {
          margin-right: 20px;
          margin-bottom: 10px;
          padding: 5px;
          display: flex;
          flex-wrap: wrap;
          align-items: center;

          .van-field {
            border: 1px solid #DCDFE6;
            border-radius: 0;
            height: 28px;
            padding: 2px 6px;
            margin-bottom: 10px;

            .van-field__body {
              height: 28px;
              margin: 0 6px;
            }

            .van-field__control {
              font-size: 14px;
            }

            .van-field__left-icon {
              margin: 5px 0 5px 5px;
            }
          }

          .van-checkbox-group, .van-radio-group {
            display: flex;
            margin-top: 5px;

            .van-checkbox, .van-radio {
              margin-right: 10px;
            }
          }

          .info {
            display: flex;
            align-items: center;
            margin-bottom: 5px;

            .field-title {
              margin-right: 10px;
            }

            .method {
              margin-right: 10px;
              border: 1px solid #4A66FA;
              color: #4A66FA;
              padding: 2px 6px;
              font-size: 12px;
            }
          }


          .filter {

          }
        }
      }
    }

    .dialog-footer {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      height: 44px;
      background-color: #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px;
      border-top: 1px solid #7F8389;

      .footer-data-tip {
        width: 200px;
        text-align: left;
        font-size: 14px;
        color: gray;
      }

      .van-button {
        margin-right: 10px;
      }
    }
  }
</style>